import { call } from 'redux-saga/effects';
import { whiteboardModeChanged } from 'features/whiteboard/actions';
import { SignalingSocket } from 'services/signaling';

export function* changeWhiteboardModeSaga(action: ReturnType<typeof whiteboardModeChanged>) {
  const { id, private: isPrivate } = action.payload;

  yield call(SignalingSocket.send, {
    event: 'changeWhiteboardMode',
    data: { id, private: isPrivate },
  });
}
